module.exports = __webpack_public_path__ + "static/news-124ba439c62d18f9358fd1ab8f0ee2ea.jpg";